import { render, staticRenderFns } from "./DetailedAssessment.vue?vue&type=template&id=7befce68&scoped=true&"
import script from "./DetailedAssessment.vue?vue&type=script&lang=js&"
export * from "./DetailedAssessment.vue?vue&type=script&lang=js&"
import style0 from "./DetailedAssessment.vue?vue&type=style&index=0&id=7befce68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7befce68",
  null
  
)

export default component.exports